(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lz-collection"] && !Shopify.designMode) return;
  try {
    
  // Collapses long SEO text to a preview with a "Read more" button. Without JS the full text shows.
  if (!customElements.get('lz-readmore')) {
    customElements.define('lz-readmore', class extends HTMLElement {
      connectedCallback() {
        const body = this.querySelector('[data-body]');
        const toggle = this.querySelector('[data-toggle]');
        if (!body || !toggle || this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.classList.add('is-collapsible');
        if (body.scrollHeight <= body.clientHeight + 8) {
          this.classList.remove('is-collapsible');
          return;
        }
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const open = this.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
          toggle.textContent = open ? this.dataset.less : this.dataset.more;
          if (!open) this.scrollIntoView({ block: 'nearest' });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-downloads"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-filter')) {
    class LzFilter extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('[data-filter]'));
        this.items = Array.from(this.querySelectorAll('[data-family]'));
        this.chips.forEach((chip) => chip.addEventListener('click', () => this.apply(chip)));
      }

      apply(active) {
        const value = active.dataset.filter;
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip === active)));
        this.items.forEach((item) => {
          item.hidden = value !== 'all' && item.dataset.family !== value;
        });
      }
    }
    customElements.define('lz-filter', LzFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-gallery')) {
    class LzGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.goTo = (index) => {
          const count = this.slides.length;
          const slide = this.slides[((index % count) + count) % count];
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        };
        this.current = () => Math.round(this.track.scrollLeft / this.track.clientWidth);
        // Gallery controls only navigate; the click never reaches other handlers (e.g. the product form)
        const control = (el, fn) => el?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          fn();
        });
        this.thumbs.forEach((thumb) => control(thumb, () => this.goTo(Number(thumb.dataset.thumb))));
        control(this.querySelector('[data-prev]'), () => this.goTo(this.current() - 1));
        control(this.querySelector('[data-next]'), () => this.goTo(this.current() + 1));
        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => {
            const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.thumbs.forEach((thumb, i) => {
              if (i === index) thumb.setAttribute('aria-current', 'true');
              else thumb.removeAttribute('aria-current');
            });
          });
        }, { passive: true });

        // Mouse drag on desktop (touch scrolls natively); snapping pauses while dragging and the slide that the
        // drag points to is snapped to on release
        if (this.slides.length > 1) {
          this.track.classList.add('is-draggable');
          let drag = null;
          this.track.addEventListener('dragstart', (event) => event.preventDefault());
          this.track.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            drag = { x: event.clientX, left: this.track.scrollLeft, index: this.current(), moved: false };
            this.track.setPointerCapture(event.pointerId);
          });
          this.track.addEventListener('pointermove', (event) => {
            if (!drag) return;
            const dx = event.clientX - drag.x;
            if (!drag.moved && Math.abs(dx) < 5) return;
            drag.moved = true;
            this.track.classList.add('is-dragging');
            this.track.scrollLeft = drag.left - dx;
          });
          const release = (event) => {
            if (!drag) return;
            const { moved, x, index } = drag;
            drag = null;
            if (!moved) return;
            const dx = event.clientX - x;
            const step = Math.abs(dx) > this.track.clientWidth * 0.15 ? (dx < 0 ? 1 : -1) : 0;
            const target = Math.min(Math.max(index + step, 0), this.slides.length - 1);
            this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: 'smooth' });
            window.setTimeout(() => this.track.classList.remove('is-dragging'), 450);
          };
          this.track.addEventListener('pointerup', release);
          this.track.addEventListener('pointercancel', release);
        }
      }
    }
    customElements.define('lz-gallery', LzGallery);
  }

  if (!customElements.get('lz-popover')) {
    class LzPopover extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-toggle]');
        this.panel = this.querySelector('[data-panel]');
        if (!this.toggle || !this.panel) return;
        this.onToggle = () => (this.panel.hidden ? this.open() : this.close());
        this.onOutside = (e) => { if (!this.contains(e.target)) this.close(); };
        this.onKey = (e) => { if (e.key === 'Escape') { this.close(); this.toggle.focus(); } };
        this.toggle.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        this.close();
        this.toggle?.removeEventListener('click', this.onToggle);
      }

      open() {
        this.panel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('pointerdown', this.onOutside);
        document.addEventListener('keydown', this.onKey);
      }

      close() {
        if (!this.panel) return;
        this.panel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('pointerdown', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }
    }
    customElements.define('lz-popover', LzPopover);
  }

  (() => {
    const init = () => {
      // Buy bar: shown while the product form is out of view (CSS limits it to phones and tablets)
      const bar = document.querySelector('[data-lz-sticky]');
      const form = document.querySelector('.lz-pdp__form');
      if (bar && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting)).observe(form);
        bar.querySelector('[data-sticky-add]')?.addEventListener('click', () => form.querySelector('button[name="add"]')?.click());
      }

      // Info pages open in a new tab, so the product stays open; product, collection and contact links stay in the tab
      const main = document.getElementById('MainContent');
      main?.querySelectorAll('a[href]').forEach((link) => {
        let url;
        try { url = new URL(link.href, location.href); } catch (e) { return; }
        if (url.origin !== location.origin || !/\/(pages|blogs|policies)\//.test(url.pathname) || /\/pages\/contact\/?$/.test(url.pathname)) return;
        link.target = '_blank';
        link.rel = 'noopener';
      });

      // Office for Mac viewed on a Windows PC (or the Windows version on a Mac): show the device hint. iPads report
      // as Mac but have touch points and are left out
      const hint = document.querySelector('[data-device-hint]');
      if (hint) {
        const platform = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';
        const isWindows = platform ? /win/i.test(platform) : /Windows NT/.test(navigator.userAgent);
        const isMac = (platform ? /mac/i.test(platform) : /Macintosh/.test(navigator.userAgent)) && navigator.maxTouchPoints < 2;
        const product = hint.dataset.deviceHint;
        if ((product === 'mac' && isWindows) || (product === 'windows' && isMac)) hint.hidden = false;
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-tabs')) {
    class LzTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll(':scope > .lz-tabs__list [role="tab"]'));
        this.panels = Array.from(this.querySelectorAll(':scope > .lz-tabs__panel'));
        if (this.tabs.length < 2) return;
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (event) => {
            const keys = { ArrowRight: 1, ArrowLeft: -1, Home: -Infinity, End: Infinity };
            if (!(event.key in keys)) return;
            event.preventDefault();
            let next = this.tabs.indexOf(tab) + keys[event.key];
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next, true);
          });
        });
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.tabs.indexOf(event.target);
          if (i > -1) this.select(i);
        });
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
      }
    }

    customElements.define('lz-tabs', LzTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lz-slideshow')) {
    class LzSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.lz-hero__slide'));
        if (this.slides.length < 2) return;
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 7000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.playing = this.dataset.autoplay === 'true' && !this.reduced;
        this.hold = false;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));
        this.toggle?.addEventListener('click', () => this.setPlaying(!this.playing));

        // No pause on hover: the hero fills the first screen, so the pointer is almost always over it
        // (and iOS keeps a tap as a permanent hover). Keyboard focus pauses; the pause button stops it.
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.pauseFor(true); });
        this.addEventListener('focusout', () => this.pauseFor(false));

        let startX = null;
        this.addEventListener('pointerdown', (e) => { startX = e.clientX; }, { passive: true });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
        }, { passive: true });

        this.onBlockSelect = (event) => {
          const slide = event.target.closest?.('.lz-hero__slide');
          if (!slide || !this.contains(slide)) return;
          this.setPlaying(false);
          this.go(Number(slide.dataset.index));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('visibilitychange', () => this.schedule());

        this.setPlaying(this.playing);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      go(target, byUser = false) {
        const count = this.slides.length;
        const next = (target + count) % count;
        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => {
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.index = next;
        if (byUser) this.schedule();
        else this.schedule();
      }

      pauseFor(hold) {
        this.hold = hold;
        this.classList.toggle('is-held', hold);
        this.schedule();
      }

      setPlaying(playing) {
        this.playing = playing;
        this.classList.toggle('is-playing', playing);
        if (this.toggle) {
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay);
          this.toggle.classList.toggle('is-paused', !playing);
        }
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        // Restart the progress animation on the active dot.
        this.dots.forEach((dot) => dot.classList.remove('is-running'));
        if (!this.playing || this.hold || document.hidden) return;
        const dot = this.dots[this.index];
        if (dot) {
          void dot.offsetWidth;
          dot.classList.add('is-running');
        }
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
    }

    customElements.define('lz-slideshow', LzSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
